<script>
  import {tick, setContext, onDestroy, getContext} from 'svelte';
  import {writable, derived} from 'svelte/store';
  import firebase from 'firebase';
  import MyChannelList from './MyChannelList.svelte';
  import Loading from "../general/Loading.svelte";
  import ChannelHeader from "./ChannelHeader.svelte";
  import DrawerContainer from "../layout/DrawerContainer.svelte";
  import DrawerToggleButton from "../layout/DrawerToggleButton.svelte";
  import MessageList from "../messages/MessageList.svelte";
  import MessageForm from "../messages/MessageForm.svelte";
  import {unlockedChannels, myChannels, unlockChannel} from './channelStore';
  import PasscodeInput from "../general/PasscodeInput.svelte";
  import {showConfirm} from "../popup/popupStore";
  import _ from 'lodash';
  import {showSnackbar} from "../snackbar/snackbarStore";
  import {editingMessageId} from '../messages/messageStore';

  export let channelId;



  let isDrawerStatic = false;
  let unsubscriber = null;

  let lastMessageId;


  const channelIdStore = writable(channelId);
  const channel = derived(
      channelIdStore,
      ($channelIdStore, set) => {
        unsubscriber && unsubscriber();
        unsubscriber = null;
        if ($channelIdStore && $myChannels && $myChannels[$channelIdStore]) {

          unsubscriber = myChannels.subscribe(val => {
            set(_.get(val, [$channelIdStore]));
          });
          return;
        }

        set(null);

        if ($channelIdStore) {
          unsubscriber = firebase.firestore().collection('channels').doc($channelIdStore).onSnapshot(snapshot => {
            if (snapshot.id !== channelId) return;
            set(snapshot);
          });
        }
      }
  );


  $: channelIdStore.set(channelId);



  let isLocked = false;

  const getIsLocked = () => {

    if (!$channel) return false;
    if ($unlockedChannels[channelId]) return false;

    return !!$channel.data().lockCode;
  };

  const unsubscribeChannel = channel.subscribe(channel => {
    isLocked = getIsLocked();
  });

  const unsubscribeUnlockedChannels = unlockedChannels.subscribe(unlockedChannels => {
    isLocked = getIsLocked();
  });

  const onEnterPasscode = code => {
    if (code === $channel.data().lockCode) {
      unlockChannel($channel.id);
    } else {
      showSnackbar('Wrong code');
    }
  };

  const onFormEvent = evt => {
    editingMessageId.set(lastMessageId);
  };

  onDestroy(() => {
    unsubscriber && unsubscriber();
    unsubscribeChannel();
    unsubscribeUnlockedChannels();
  });

</script>

<DrawerContainer bind:isStatic={isDrawerStatic}>
  <div slot="content" class="content">
      {#if !$channel}
        <Loading fullscreen/>
      {/if}
      {#if $channel}
          {#if isLocked}
            <PasscodeInput style="width: 100%; height: 100%" onComplete={onEnterPasscode}/>
          {/if}
          {#if !isLocked}
            <div class="column" style="height: 100%;">
              <div class="row header-wrapper align-center">
                  {#if !isDrawerStatic}
                    <DrawerToggleButton style="margin-right: -12px;"/>
                  {/if}
                <ChannelHeader channel={$channel}/>
              </div>
              <div class="expand">
                <MessageList channelId={$channel.id} bind:lastMessageId />
              </div>
              <MessageForm channelId={$channel.id} on:editlastmessage={onFormEvent}/>
            </div>
          {/if}
      {/if}

  </div>
  <div slot="drawer" class="drawer-content">
    <MyChannelList darkTheme style="height: 100%;"/>
  </div>
</DrawerContainer>


<style>
  .content {
    height: 100%;
  }

  .header-wrapper {
    border-bottom: 1px solid #ddd;
  }

  .drawer-content {
    height: 100%;
    background-color: black;
  }
</style>